import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const ThinHeader = ({
  homeTo = '/',
  onToggleLeaderboard,
  leaderboardOpen = false,
  userLabel = 'Player',
  showAdminLink = false,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const showHomeLink = location.pathname !== homeTo;

  return (
    <div className={`thin-top-header ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      <div className="thin-top-left">
        <button
          type="button"
          className="thin-header-btn thin-header-menu-btn"
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen((prev) => !prev)}
        >
          ☰
        </button>
        <div className={`thin-top-links ${mobileMenuOpen ? 'open' : ''}`}>
        {showHomeLink && (
          <Link to={homeTo} className="thin-header-btn">Lounge</Link>
        )}
        {showAdminLink && (
          <Link to="/admin" className="thin-header-btn">Admin</Link>
        )}
        <Link to="/stats" className="thin-header-btn">Stats</Link>
        <Link to="/profile" className="thin-header-btn">Profile</Link>
        {onToggleLeaderboard && (
          <button
            className="thin-header-btn"
            onClick={onToggleLeaderboard}
            type="button"
          >
            {leaderboardOpen ? 'Hide Leaderboard' : 'Leaderboard'}
          </button>
        )}
        </div>
      </div>
      <div className="thin-top-right">
        <Link to="/guide" className="thin-header-btn thin-help-btn" aria-label="How to guide" title="How To">?</Link>
        <span className="thin-user-pill">{userLabel}</span>
      </div>
    </div>
  );
};

export default ThinHeader;
